<template>
  <div class="x-tablelist-view" data-automation="manageProduct">
    <!-- 搜索行 -->
    <ux-searchOption
      class="product-list-option"
      :layout="layout"
      :data="filter"
      :isBreak="true"
      @search="seach"
      @clear="clear"
      @showAdd="showAdd"
    ></ux-searchOption>

    <div class="product-list-center">
      <!-- <ux-button v-if="this.$hasModule(20)" type="primary" icon="ux_icon_plus" @click="showAdd">
        {{ $t('HT.add') }}</ux-button
      > -->
      <span class="product-list-total">{{
        $t('HT.orderOverview.total', { total: tableData.totalSize })
      }}</span>
    </div>

    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        class="product-list-table"
        layout="total, sizes, prev, pager, next"
        :emptyText="$t('HT.nodata')"
        :hide-on-single-page="true"
        :data="tableData.list"
        :total="tableData.totalSize"
        :columns="columns"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
      ></ux-table>
    </div>
  </div>
</template>

<script>
import mySearchOption from '@c/mySearchOption/mySearchOption';
import addProductType from './template/addProductType';
export default {
  name: 'productType',
  components: {
    addProductType,
    mySearchOption
  },
  data() {
    return {
      // 是否显示分页
      showPage: true,
      layout: [
        // 搜索项配置
        {
          width: '272px',
          type: 'input',
          key: 'name',
          hideBtn: true,
          placeholder: this.$t('HT.rules.addProduct.type')
        },
        {
          type: 'button',
          text: this.$t('HT.search'),
          show: true,
          event: 'search',
          spacing: '20px'
        },
        {
          type: 'button',
          text: this.$t('HT.reset'),
          plain: true,
          event: 'clear'
        },
        {
          type: 'button',
          text: this.$t('HT.add'),
          icon: 'ux_icon_plus',
          hidden: !this.$hasModule(20),
          right: true,
          event: 'showAdd'
        }
      ],
      columns: [
        // 表头数据
        {
          label: this.$t('HT.productAll.type'),
          prop: 'name',
          tooltip: true
        },
        {
          label: this.$t('HT.existing.products'),
          prop: 'product_name',
          tooltip: true
        },
        {
          label: this.$t('HT.createdTime'),
          prop: 'created_date',
          tooltip: true
        },
        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(20),
          width: 200,
          render: (h, params) => {
            return h('span', {}, [
              h(
                'ux-button',
                {
                  props: {
                    type: 'primary',
                    text: true
                  },
                  attrs: {
                    style: 'margin-right: 10px'
                  },
                  on: {
                    click: () => {
                      this.editType(params);
                    }
                  }
                },
                this.$t('HT.edit')
              ),
              h(
                'ux-button',
                {
                  props: {
                    type: 'primary',
                    text: true
                  },
                  attrs: {
                    style: 'margin-right: 10px'
                  },
                  on: {
                    click: () => {
                      this.delete(params);
                    }
                  }
                },
                this.$t('HT.delete')
              )
            ]);
          }
        }
      ],
      filter: {
        // 查询参数
        name: '', // 产品类型
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },
  created() {
    this.getList(this.filter);
  },
  mounted() {
    // document.querySelector('.product-list-table .ux-pagination').classList.remove('is-background');
  },

  methods: {
    /**
     * 清除
     */
    clear() {
      this.filter.name = '';
      this.filter.page = 1;
    },
    /**
     * @description: 管理
     * @param {Object} 一条表数据
     */
    manage(params) {
      this.$router.push({
        name: 'productInfo',
        query: {
          // 对象最好转换一下
          params: JSON.stringify(params)
        }
      });
    },
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.product.getAllProductType(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 添加列表
     * @param {Object} params 表单提交参数
     */
    addProductType(params) {
      this.$uxLoading.show();
      this.$api.product.addProductType(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 上架
     * @param {Object} params 表单参数
     */
    startUp(params) {
      const title = this.$t('HT.productAll.startUp');
      const content = this.$t('HT.productAll.startUp.content');
      this.$uxModal.show({
        title,
        content,
        type: 'warning',
        confirm: () => {
          this.$api.product.userAuditProducts(params.id, { published: 1 }).then((res) => {
            if (res.code == 10000) {
              this.$uxModal.hide();
              this.$uxMessage.success(this.$t('HT.productAll.startUp.success'));
              this.getList(this.filter);
            }
          });
        }
      });
    },

    /**
     * 下架
     * @param {Object} params 表单参数
     */
    endDown(params) {
      const title = this.$t('HT.productAll.endDown');
      const content = this.$t('HT.productAll.endDown.content');
      this.$uxModal.show({
        title,
        content,
        type: 'warning',
        confirm: () => {
          this.$uxLoading.show();
          this.$api.product
            .release(params.id, {
              published: 0
            })
            .then((res) => {
              if (res.code == 10000) {
                this.$uxModal.hide();
                this.$uxMessage.success(this.$t('HT.apiList.soldOutApi.success'));
                this.getList(this.filter);
              }
            });
        }
      });
    },

    /**
     * 删除
     * @param {Object} params 表单参数
     */
    delete(params) {
      console.log(params);
      const title = this.$t('HT.productAll.del');
      const error = this.$t('HT.productType.delError');
      const content = this.$t('HT.productAll.del.content');
      this.$uxModal.show({
        title,
        content: params.product_name ? content + '\n' + error : content,
        confirm: () => {
          params.product_name ? this.$uxModal.hide() : this.delList(params);
        }
      });
    },

    /**
     * 删除列表
     * @param {String} id 唯一标识
     */
    delList(params) {
      // this.$uxLoading.show();
      if (params.id) {
        this.$api.product.delProductType(params.id).then((res) => {
          if (res.code == 10000) {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
            if (this.tableData.list.length === 1) {
              this.filter.page = this.filter.page - 1 ? this.filter.page - 1 : 1;
            }
            this.getList(this.filter);
          }
        });
      } else {
        this.$uxModal.hide();
        this.$uxMessage.error(this.$t('HT.addApi.delError'));
        this.getList(this.filter);
      }
    },

    /**
     * 新增-弹窗
     */
    showAdd() {
      const title = this.$t('HT.productAll.add');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addProductType);
        },
        confirm: (data) => {
          // this.addList(data);
          this.addProductType(data);
        }
      });
    },

    /**
     * 搜索
     */
    seach() {
      this.filter.page = 1;
      this.getList(this.filter);
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    },
    editType(param) {
      const title = this.$t('HT.edit');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addProductType, { props: { data: param }});
        },
        confirm: (data) => {
          this.$api.product.putProductType(data.id, {name: data.name}).then(() => {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.addApi.editSuccess'));
            this.getList();
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.x-tablelist-view {
  height: 100%;
  margin: 0;
  background: none;
  border: none;
  padding: 20px 40px 0 20px;

  .product-list-option {
    padding: 32px 0px 0px 0px;
    margin-bottom: 24px;
    background: #fff;
    border-radius: 8px;
  }

  .product-list-center {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .product-list-total {
      color: $color-text-secondary;
      height: 20px;
      line-height: 20px;
      margin-left: 20px;
    }

  }

  ::v-deep .product-list-table .ux-pagination {
    text-align: right;
    padding: 20px 0 32px;

    .btn-next,
    .btn-prev {
      height: 32px;
      background: transparent;
    }

    .el-pager {
      .el-icon-more,
      .number,
      .btn-quicknext:hover {
        height: 32px;
        line-height: 32px;
        background: transparent;
      }
    }

    .el-pagination__sizes .el-select .el-input {
      .el-input__inner {
        border: none;
        background: transparent;
      }
    }
  }
}
</style>
